import React, { useState } from 'react';

/**
 * A POS outlet report uploaded on the normal TSR page is filed ONE OUTLET AT A
 * TIME: the owner picks an outlet, its lines load into the normal scan table,
 * and it is submitted as an ordinary TSR — every normal popup included. Outlets
 * already filed for the day are marked and cannot be picked again; the online
 * outlet is not filed here (online orders come from the Swiggy/Zomato reports).
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const formatDay = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? `${m[3]} ${MONTHS[Number(m[2]) - 1]} ${m[1]}` : String(iso || '');
};
const rupees = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const plates = (n) => `${Number(n) || 0} plate${Number(n) === 1 ? '' : 's'}`;

const buttonStyle = (primary, disabled) => ({
    flex: 1, padding: '10px 20px', height: '42px', borderRadius: '8px', fontWeight: '600', fontSize: '14px',
    cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1,
    backgroundColor: primary ? '#000' : '#fff', color: primary ? '#fff' : '#000',
    border: primary ? 'none' : '1px solid #d1d5db',
    display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap'
});

export default function OutletPickerPopup({ picker, onPick, onCancel }) {
    const [chosen, setChosen] = useState(null);
    const outlets = (picker && picker.outlets) || [];
    const skipped = (picker && picker.skipped) || [];
    const open = outlets.filter((o) => !o.filed);

    return (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
            <div className="modal-content" role="dialog" aria-label="Choose an outlet" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px', borderRadius: '20px' }}>
                <div className="modal-header">
                    <h2 style={{ color: '#000', textAlign: 'center', flex: 1, margin: '20px 20px 0 20px', fontSize: '1.3rem', fontWeight: 700 }}>
                        Outlet report — choose an outlet
                    </h2>
                </div>
                <div className="modal-body" style={{ padding: '16px 20px 12px 20px' }}>
                    {open.length === 0 && (
                        <p style={{ color: '#065f46', background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: '8px', padding: '10px 12px', fontSize: '14px', textAlign: 'left' }}>
                            Every outlet in this report is already filed for {formatDay(picker?.report_date)}.
                        </p>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'left' }}>
                        {outlets.map((o) => (
                            <label
                                key={o.name}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px',
                                    border: chosen === o.name ? '2px solid #000' : '1px solid #e5e7eb', borderRadius: '8px',
                                    background: o.filed ? '#f9fafb' : '#fff', cursor: o.filed ? 'default' : 'pointer',
                                    color: o.filed ? '#9ca3af' : '#111827',
                                }}
                            >
                                <input
                                    type="radio"
                                    name="outlet-picker"
                                    value={o.name}
                                    aria-label={o.name}
                                    checked={chosen === o.name}
                                    disabled={o.filed}
                                    onChange={() => setChosen(o.name)}
                                    style={{ accentColor: '#000', cursor: o.filed ? 'default' : 'pointer', width: '16px', height: '16px' }}
                                />
                                <span style={{ flex: 1 }}>
                                    <span style={{ fontWeight: 600 }}>{o.name}</span>
                                    <span style={{ display: 'block', fontSize: '13px', color: o.filed ? '#9ca3af' : '#6b7280' }}>
                                        {plates(o.paid_qty)} · {rupees(o.revenue)}
                                        {o.nc_qty > 0 ? ` · ${o.nc_qty} NC` : ''}
                                    </span>
                                </span>
                                {o.filed && (
                                    <span style={{ fontSize: '12px', fontWeight: 700, color: '#065f46', background: '#d1fae5', borderRadius: '999px', padding: '2px 8px' }}>
                                        Filed
                                    </span>
                                )}
                            </label>
                        ))}
                    </div>

                    {skipped.length > 0 && (
                        <p style={{ color: '#6b7280', fontSize: '13px', lineHeight: '1.5', marginTop: '12px', textAlign: 'left' }}>
                            Not filed here: <strong>{skipped.map((s) => s.name).join(', ')}</strong> — online orders come from the Swiggy/Zomato order reports.
                        </p>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '12px', padding: '0 20px 20px 20px' }}>
                    <button type="button" style={buttonStyle(false, false)} onClick={onCancel}>
                        Cancel
                    </button>
                    {open.length > 0 && (
                        <button type="button" style={buttonStyle(true, !chosen)} disabled={!chosen} onClick={() => chosen && onPick(chosen)}>
                            {chosen ? chosen : 'Select outlet'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
